import React from 'react';
import InfoValue from '../../shared/components/InfoValue';
import { MLTag } from '../../shared/types/mediaLibraryTag';

interface ITagInfo {
  tag: MLTag;
}

const TagInfo: React.FC<ITagInfo> = ({ tag }) => {
  return (
    <>
      <InfoValue value={tag?.type} label={'Type'} />
      <InfoValue value={tag?.label} label={'Label'} />
      <InfoValue value={tag?.value} label={'Value'} />
    </>
  );
};

export default TagInfo;
